//Route Types
import Layout from "../layout/Layout";

// Import all screens directly

// Public route components
import HomePage from "../pages/HomePage";
import ContactPage from "../pages/ContactPage";

// Private Route components

import { ComponentType } from "react";

// Config 
import { AppRouteURL } from "../data/route/AppRouteURL";
import BenefitsPage from "../pages/BenefitsPage";
import TryItPage from "../pages/TryItPage";
import Playground from "../pages/Playground";


type LayoutWrapperType = typeof Layout;

export enum RouteType{
  Public = "public",
  Private = "Private"
}

export interface RouteConfig {
  routeType: RouteType;
  path: string;
  component: ComponentType<any>;
  wrapper: LayoutWrapperType;
  extraProps?: Record<string, any>;
}

// Define route configurations
export const routeConfigList: RouteConfig[] = [
  {
    routeType: RouteType.Public,
    path: AppRouteURL.HomePage,
    component: Playground,
    wrapper: Layout,
  },
  {
    routeType: RouteType.Public,
    path: AppRouteURL.ContactPage,
    component: ContactPage,
    wrapper: Layout,
  },
  {
    routeType: RouteType.Public,
    path: AppRouteURL.BenefitPage,
    component: BenefitsPage,
    wrapper: Layout,
  },
  {
    routeType: RouteType.Public,
    path: AppRouteURL.TryItPage,
    component: Playground,
    wrapper: Layout,
  },
  {
    routeType: RouteType.Public,
    path: AppRouteURL.Playground,
    component: Playground,
    wrapper: Layout,
  },
];